interface BillingEmailSectionProps {
  email: string
}

const BillingEmailSection = ({ email }: BillingEmailSectionProps) => {
  return (
    <div className="pt-12">
      <div className="pb-4 border-b border-neutral-200">
        <h2 className="text-lg font-bold">Billing Email</h2>
      </div>
      <div className="text-gray-700 pt-6">{email}</div>
    </div>
  )
}

export default BillingEmailSection
